import React from 'react';
import { Fingerprint, Building2 } from 'lucide-react';
interface ScreenProps {
  onNavigate: (screenId: number) => void;
}
export function Screen1({
  onNavigate
}: ScreenProps) {
  return <div className="min-h-full bg-datmont-900 flex flex-col items-center justify-between p-6 pb-10 relative overflow-hidden" data-id="element-15">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-datmont-blue/20 rounded-full blur-3xl" data-id="element-16"></div>

      <div className="w-full flex-1 flex flex-col items-center justify-center relative z-10 mt-12" data-id="element-17">
        <img src="https://cdn.magicpatterns.com/uploads/dN76LW7ZJU33sweBnWUYDh/Datmont_with_Apostel_Seal_copy.png" alt="Datmont Logo" className="h-20 object-contain mb-4 brightness-0 invert" data-id="element-18" />
        <h1 className="text-2xl font-bold text-white tracking-tight mb-1" data-id="element-19">
          DATMONT™
        </h1>
        <p className="text-sm text-slate-400 mb-16" data-id="element-20">
          Global Document Authentication
        </p>

        <div className="w-full bg-white rounded-3xl p-8 flex flex-col items-center shadow-2xl" data-id="element-21">
          <h2 className="text-lg font-semibold text-datmont-900 mb-8" data-id="element-22">
            Authenticate to Continue
          </h2>

          <button onClick={() => onNavigate(2)} className="relative group cursor-pointer mb-6" data-id="element-23">
            <div className="absolute inset-0 bg-blue-50 rounded-full scale-150 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-24"></div>
            <div className="w-24 h-24 rounded-full border-2 border-datmont-blue/20 flex items-center justify-center relative z-10 bg-white" data-id="element-25">
              <div className="w-20 h-20 rounded-full border border-datmont-blue/40 flex items-center justify-center bg-blue-50/50" data-id="element-26">
                <Fingerprint className="w-12 h-12 text-datmont-blue" strokeWidth={1} data-id="element-27" />
              </div>
            </div>
            {/* Animated scanning lines effect could go here */}
          </button>

          <p className="text-sm font-medium text-datmont-900 mb-1" data-id="element-28">
            Face ID / Fingerprint
          </p>
          <p className="text-xs text-slate-500 mb-6" data-id="element-29">Secure Authentication</p>

          <div className="w-full flex items-center gap-4 mb-6" data-id="element-30">
            <div className="h-px bg-slate-100 flex-1" data-id="element-31"></div>
            <span className="text-xs text-slate-400" data-id="element-32">or</span>
            <div className="h-px bg-slate-100 flex-1" data-id="element-33"></div>
          </div>

          <button className="text-sm font-medium text-datmont-blue hover:text-blue-700 transition-colors" data-id="element-34">
            Sign in with Email
          </button>
        </div>
      </div>

      <button onClick={() => onNavigate(8)} className="w-full py-4 flex items-center justify-center gap-2 text-white/80 hover:text-white border border-white/10 rounded-xl hover:bg-white/5 transition-all relative z-10" data-id="element-35">
        <Building2 className="w-5 h-5" data-id="element-36" />
        <span className="text-sm font-medium" data-id="element-37">Access as Institution</span>
      </button>
    </div>;
}